import { devtools } from "zustand/middleware";
import { create } from "zustand/react";
import { ContractLight } from "@/types";

type ContractBulkEditState = {
  editMode: string | null;
  setEditMode: (editMode: "price" | null) => void;
  selectedRows: ContractLight[];
  contractType: string | null;
  setContractType: (contractType: string | null) => void;
  toggleRow: (row: ContractLight, checked: boolean) => void;
  clearSelection: () => void;
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
};

export const useContractBulkEditStore = create<ContractBulkEditState>()(
  devtools((set, _) => ({
    editMode: null,
    setEditMode: (editMode) => set({ editMode }),
    selectedRows: [],
    contractType: null,
    setContractType: (contractType) => set({ contractType }),
    toggleRow: (row, checked) =>
      set((state) => {
        const nextSelectedRows = checked
          ? [...state.selectedRows, row]
          : state.selectedRows.filter((i) => i.id !== row.id);

        return {
          selectedRows: nextSelectedRows,
          contractType: nextSelectedRows.length === 0 ? null : state.contractType,
        };
      }),
    clearSelection: () => set({ selectedRows: [], contractType: null }),
    isModalOpen: false,
    openModal: () => set({ isModalOpen: true }),
    closeModal: () => set({ isModalOpen: false }),
  }))
);
